import { BasicModel } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2TourTableWinDialogProperties } from "./Poker2TourTableWinDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2TourTableWinDialog extends Poker2Dialog {
    public static NAME: string = "Poker2TourTableWinDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.standardDialog.btn_ok.label = BasicModel.languageData.getTextById("generic_btn_okay");
        if (this.standardDialogProperties.round != 3) {
            this.standardDialog.txt_round.text = Poker2Model.languageData.getTextById("dialog_tableend_nextround", [""]);
            this.standardDialog.txt_round_no.text = String(this.standardDialogProperties.round);
        }
        else {
            this.standardDialog.txt_round.text = Poker2Model.languageData.getTextById("dialog_tableend_lastround");
            this.standardDialog.txt_round_no.text = "";
        }
        this.standardDialog.txt_title.text = Poker2Model.languageData.getTextById("dialog_tableend_title");
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.standardDialog.txt_copy, Poker2Model.languageData.getTextById("dialog_tableend_copy"), 7);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.standardDialog.btn_close:
                this.hide();
                break;
            case this.standardDialog.btn_ok:
                this.hide();
                if (this.standardDialogProperties.functionOk != null)
                    this.standardDialogProperties.functionOk();
                break;
        }
    }

    protected get standardDialogProperties(): Poker2TourTableWinDialogProperties {
        return this.properties as Poker2TourTableWinDialogProperties;
    }

    protected get standardDialog(): Library.PokerPopUps.PokerTourTableWin {
        return this.disp as Library.PokerPopUps.PokerTourTableWin;
    }
}
